import { isRectangleContaining } from 'framework/utils/math-utils';
import { HexGridType, IHexGridData } from 'js/bubbleCore/types';

export function isInGrid<T>(config: IHexGridData<T>, col: number, row: number): boolean {
  if (!isRectangleContaining(col, row, config.limits)) return false;

  if (config.asymetrical) {
    switch (config.type) {
      case HexGridType.OddR: return checkAsymetricalOddR(col, row, config.limits.width);
      case HexGridType.EvenR: return checkAsymetricalEvenR(col, row, config.limits.width);
      case HexGridType.OddQ: return checkAsymetricalOddQ(col, row, config.limits.height);
      case HexGridType.EvenQ: return checkAsymetricalEvenQ(col, row, config.limits.height);
    }
  }

  return true;
}

function checkAsymetricalOddR(
  offsetCol: number, offsetRow: number, widthLimit: number
): boolean {
  if (offsetRow % 2 === 0) return true;
  return offsetCol < widthLimit - 1;
}

function checkAsymetricalEvenR(
  offsetCol: number, offsetRow: number, widthLimit: number
): boolean {
  if (offsetRow % 2 === 1) return true;
  return offsetCol < widthLimit - 1;
}

function checkAsymetricalOddQ(
  offsetCol: number, offsetRow: number, heightLimit: number
): boolean {
  if (offsetCol % 2 === 0) return true;
  return offsetRow < heightLimit;
}

function checkAsymetricalEvenQ(
  offsetCol: number, offsetRow: number, heightLimit: number
): boolean {
  if (offsetCol % 2 === 1) return true;
  return offsetRow < heightLimit;
}